import * as React from 'react';
import {withAuthorization} from "../../firebase/withAuthorization";
import remergeCondition from "../../firebase/conditions";
import less from "../../components/less-service"
import {ChangeEvent} from "react";

import nunjucks from "../../components/nunjucks-service"
import styles from "../../components/BannerEditor/BannerPreviewer.module.less";
import {lessData, sassData} from "../../store/banner/editor/css";
import {customCodeData, indexHtmlData} from "../../store/banner/editor/template";
import {rl} from "../../store/banner/editor/reducers";
import {user} from "../../store/banner/editor/user";

import sass from "../../components/Sass/sass.parser.worker";
import WebWorker from "../../components/WebWorker";
import BasicLayout from "../../layout/BasicLayout";

nunjucks.configure({
    autoescape: true,
    tags: {
        blockStart: '<%',
        blockEnd: '%>',
        variableStart: '{%',
        variableEnd: '%}',
        commentStart: '<#',
        commentEnd: '#>'
    }
});

export interface Props {
    title: string;
}


interface IProps {

}

interface IState {
    lessValue: string;
    sassValue: string;
    templateValue: string;
    customCodeValue: string;
    testingLess: boolean;
    css: string;
    html: string;
}

class Home extends React.Component<IProps, IState> {
    state: IState = {
        lessValue: lessData,
        sassValue: sassData,
        templateValue: indexHtmlData,
        customCodeValue: customCodeData,
        testingLess: false,
        css: '',
        html: ''
    };

    worker: WebWorker;

    constructor(props: IProps) {
        super(props);
        this.worker = new WebWorker(sass);

    }

    componentDidMount(): void {
        this.worker.addEventListener("message", event => {
            this.setState({css: event.data});

            let x = nunjucks.renderString(this.state.templateValue, {css: event.data});
            x = rl.Parse(x, user, this.state.customCodeValue);
            this.setState({html: x});
        });
    }

    testSass = () => {
        this.setState({testingLess: false});
        this.worker.postMessage(this.state.sassValue);

    };

    testLess = () => {
        this.setState({testingLess: true});
        less.render(this.state.lessValue, {}, (error: Error, output: any) => {
            if (error) {
                this.setState({css: error.message});
                return
            }
            this.setState({css: output.css});
            let x = nunjucks.renderString(this.state.templateValue, {css: output.css, username: 'James'});
            x = rl.Parse(x, user, this.state.customCodeValue);
            this.setState({html: x})
        })
    };

    updateLessValue = (value: ChangeEvent<HTMLTextAreaElement>) => {
        this.setState({lessValue: value.target.value});
        this.testLess()
    };

    updateSassValue = (value: ChangeEvent<HTMLTextAreaElement>) => {
        this.setState({sassValue: value.target.value});
        this.testSass()
    };

    updateTemplateValue = (value: ChangeEvent<HTMLTextAreaElement>) => {
        this.setState({templateValue: value.target.value});
        if (this.state.testingLess) {
            this.testLess()
        } else {
            this.testSass()
        }
    };

    updateCustomCodeValue = (value: ChangeEvent<HTMLTextAreaElement>) => {
        this.setState({customCodeValue: value.target.value});
        if (this.state.testingLess) {
            this.testLess()
        } else {
            this.testSass()
        }
    };

    render() {
        return (
            <BasicLayout>
                <div className="hello">
                    <button onClick={this.testLess}>
                        Test Less
                    </button>

                    <button onClick={this.testSass}>
                        Test Sass
                    </button>

                    <span>less
                        <textarea
                            value={this.state.lessValue}
                            onChange={this.updateLessValue}
                            rows={20}
                            style={{width: 300}}
                        />
                    </span>
                    <span>sass
                        <textarea
                            value={this.state.sassValue}
                            onChange={this.updateSassValue}
                            rows={20}
                            style={{width: 300}}
                        />
                    </span>
                    <span> template
                        <textarea
                            value={this.state.templateValue}
                            onChange={this.updateTemplateValue}
                            rows={20}
                            style={{width: 300}}
                        />
                    </span>
                    <span>custom code
                        <textarea
                            value={this.state.customCodeValue}
                            onChange={this.updateCustomCodeValue}
                            rows={20}
                            style={{width: 300}}
                        />
                    </span>
                    <span>css<textarea value={this.state.css} readOnly={true} rows={20} style={{width: 300}}/></span>
                    <span>html<textarea value={this.state.html} readOnly={true} rows={20} style={{width: 300}}/></span>

                    <iframe
                        className={styles.iframe}
                        srcDoc={this.state.html}
                        width={300}
                        height={300}
                    />
                </div>
            </BasicLayout>
        );
    }
}

const authCondition = (authUser: any) => remergeCondition(authUser);

export default withAuthorization(authCondition)(Home);
